import { h, Component } from "preact";
import { isSameDay } from "date-fns";
import EventListHeaderDesktop from "./EventListHeaderDesktop";
import EventListHeaderMobile from "./EventListHeaderMobile";
import actions from "../actions";
import NoDataWidgetError from "../../common/components/NoDataWidgetError";
import Spinner from "../../common/components/Spinner";
import WidgetError from "../../common/components/WidgetError";
import { isMobileOnly } from "react-device-detect";
import PeriodRow from "./rows/PeriodRow";
import EventRowData from "./rows/EventRowData";
import EventRowDetailDesktop from "./rows/EventRowDetailDesktop";
import EventRowDetailMobile from "./rows/EventRowDetailMobile";
import EventDetailModal from "./modal/EventDetailModal";
import EventNotifyModal from "./modal/EventNotifyModal";
import { connectWithTranslations } from "../../common/helpers/translationsHelpers";
import {
    persistSettings,
    getSettingsWithNoFilter,
} from "../../calendar-common/helpers/settingsHelper";

class EventList extends Component {
    constructor(props) {
        super(props);
        this.buildRows = this.buildRows.bind(this);
    }
    haveDifferentDays(e1, e2) {
        const result = !isSameDay(e1.date, e2.date);
        return result;
    }
    initNotificationSetting() {
        let setting = getSettingsWithNoFilter();

        if (setting && !setting.hasOwnProperty("eventNotifyShown"))
            persistSettings({
                eventNotifyShown: true,
            });
    }

    getNotificationSetting() {
        let settings = getSettingsWithNoFilter();
        if (settings)
            return settings.eventNotifyShown;

        return null;
    }

    componentDidMount() {
        this.initNotificationSetting();
    }

    buildRows(
        eventDates,
        isFetching,
        eventDatesFetchError,
        eventNotifications
    ) {
        let result = [];

        if (isFetching) {
            result.push(this.createElementWrapper(<Spinner />));
        } else {
            if (eventDatesFetchError) {
                result.push(
                    this.createElementWrapper(
                        <WidgetError
                            message={
                                <p>
                                    {this.props.translate(
                                        "WidgetErrorMessageLine1"
                                    )}
                                    <br />
                                    {this.props.translate(
                                        "WidgetErrorMessageLine2"
                                    )}
                                </p>
                            }
                        />
                    )
                );
            } else {
                if (eventDates && eventDates.length > 0) {
                    for (let i = 0; i < eventDates.length; i++) {
                        const prevEvent = i > 0 ? eventDates[i - 1] : null;
                        const event = eventDates[i];
                        if (
                            !prevEvent ||
                            this.haveDifferentDays(prevEvent, event)
                        ) {
                            const periodRow = (
                                <PeriodRow
                                    key={event.date.toISOString()}
                                    date={event.date}
                                />
                            );
                            result.push(periodRow);
                        }

                        const { notificationsSupported } = this.props;
                        const canBeSubscribed =
                            notificationsSupported && !event.isAllDay;
                        const isSubscribed =
                            eventNotifications &&
                            eventNotifications.includes(event.eventId);
                        const eventRow = (
                            <EventRowData
                                key={event.id + "_eventrowdata"}
                                event={event}
                                canBeSubscribed={canBeSubscribed}
                                isSubscribed={isSubscribed}
                            />
                        );
                        result.push(eventRow);

                        if (isMobileOnly) {
                            const EventRowDetailMobileItem = (
                                <EventRowDetailMobile
                                    key={event.id + "_EventRowDetailMobile"}
                                    event={event}
                                    canBeSubscribed={canBeSubscribed}
                                    isSubscribed={isSubscribed}
                                />
                            );
                            result.push(EventRowDetailMobileItem);
                        } else {
                            const EventRowDetailDesktopItem = (
                                <EventRowDetailDesktop
                                    key={event.id + "_EventRowDetailDesktop"}
                                    event={event}
                                    canBeSubscribed={canBeSubscribed}
                                    isSubscribed={isSubscribed}
                                />
                            );
                            result.push(EventRowDetailDesktopItem);
                        }
                    }
                    if (isMobileOnly) {
                        const eventModalDetail = <EventDetailModal />;
                        result.push(eventModalDetail);
                    }
                } else {
                    result.push(
                        this.createElementWrapper(
                            <NoDataWidgetError
                                message={
                                    <p>
                                        {this.props.translate(
                                            "NoDataWidgetErrorMessageLine1"
                                        )}
                                        <br />
                                        {this.props.translate(
                                            "NoDataWidgetErrorMessageLine2"
                                        )}
                                    </p>
                                }
                            />
                        )
                    );
                }
            }
        }
        return result;
    }

    createElementWrapper(children) {
        if (isMobileOnly)
            return (
                <tr>
                    <td colSpan="5">{children}</td>
                </tr>
            );
        else
            return (
                <tr>
                    <td colSpan="11">{children}</td>
                </tr>
            );
    }

    render({
        eventDates,
        isFetching,
        eventDatesFetchError,
        eventNotifications,
        eventNotifyShown,
        showEventNotifyModal,
    }) {
        return isMobileOnly ? (
            <table class="fxs_c_table">
                <EventListHeaderMobile />
                <tbody>
                    {this.buildRows(
                        eventDates,
                        isFetching,
                        eventDatesFetchError,
                        eventNotifications
                    )}
                </tbody>
            </table>
        ) : (
            <table cellSpacing="0" class="fxs_c_table">
                <EventListHeaderDesktop />
                <tbody>
                    {this.buildRows(
                        eventDates,
                        isFetching,
                        eventDatesFetchError,
                        eventNotifications
                    )}
                </tbody>
            </table>
        );
    }
}

export default connectWithTranslations(
    "eventDates, eventNotifications, isFetching, eventDatesFetchError, config, notificationsSupported, eventNotifyShown",
    actions
)(EventList);
